import { render } from "./Sessions.vue?vue&type=template&id=b8d1a63e"
import script from "./Sessions.vue?vue&type=script&lang=js"
export * from "./Sessions.vue?vue&type=script&lang=js"

import exportComponent from "/home/zoa/Documents/vue_dev/rachaelmason/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__